import React from 'react';
import '../../assets/css/loading/loading.css';

const TableLoading = () => {
  return (
    <div className="table-loading-overlay">
      <div className="spinner"></div>
      <p>Loading data...</p>
    </div>
  );
};

export default TableLoading;
